import React, { useState, useEffect } from 'react';
import { Text, Button, EditButton, SignaturePad } from 'mymoria-ui/components';
import { form } from 'data';
import { useFormikContext } from 'formik';
import moment from 'moment';
import { InputField } from 'forms/fields';
import { styled } from 'mymoria-ui';
import config from 'config';
import { Poa } from 'types';
import StyledCard from 'components/StyledCard';
import { global as t } from 'data';

const {
  digitalSignature: { title, description, buttonText },
} = form;

const StyledInput = styled(InputField)`
  margin-right: 1rem;
`;

const Flex = styled.div`
  display: flex;
`;

const StyledText = styled(Text)`
  margin-bottom: 2rem;
`;

const Signature = () => {
  const [open, setOpen] = useState(false);
  const { setFieldValue, values } = useFormikContext<Poa>();

  useEffect(() => {
    setFieldValue('signature.date', moment().format(config.dateFormat.view));
  }, [setFieldValue, values]);

  return (
    <StyledCard title={title}>
      {values.signature?.img ? (
        <>
          <Flex>
            <StyledInput name="signature.place" label={form.digitalSignature.signaturePlace} />
            {/* what is this ,den? you can move it to translation */}
            <Text>
              {t.labels.the} {values?.signature.date}
            </Text>
          </Flex>

          <img width="50%" src={values?.signature.img} alt={form.digitalSignature.title} />
          <EditButton type="button" onClick={() => setOpen(true)} />
        </>
      ) : (
        <>
          <StyledText>{description}</StyledText>
          <Button type="button" block outline onClick={() => setOpen(true)}>
            {buttonText}
          </Button>
        </>
      )}
      {open && (
        <SignaturePad
          labels={{
            signatureEmptyValidator: t.validators.signatureEmpty,
            writeAboveLine: form.digitalSignature.aboveLine,
            screenRotation: form.digitalSignature.screenRotation,
            footer: {
              cancel: t.labels.cancel,
              save: t.labels.save,
              again: t.labels.again,
            },
          }}
          onClose={() => setOpen(false)}
          save={dataURL => setFieldValue('signature.img', dataURL)}
        />
      )}
    </StyledCard>
  );
};

export default Signature;
